/** The three surfaces under Marketing, carried as ?view= on /campaign. */
export const MARKETING_VIEWS = {
  campaigns: 'campaigns',
  calendar: 'calendar',
  website: 'website',
};
